import pic1 from './revtrend.png';
import pic2 from './dataviz.png';

const analytics = [
    {
        id: 1,
        image: pic1,
        title: "Rev Trend",
        Desc: "Utilized a demo Excel file with data on two hotel types, employing SQL commands (e.g., SELECT, LEFT JOIN, GROUP BY) to import it into Power BI. Focused on key questions for the dashboard: examining hotel revenue growth by year and type, evaluating parking space expansion necessity, and presenting trends through an interactive dashboard with SQL queries.",
        stack: "MS Power BI, SQL",
        Github: "https://github.com/sanikaardekar/Data-Visualization",
        Link: "http://bit.ly/3O5WLoy",
        Mentions: "Practise Project"

    },
    {
        id: 2,
        image: pic2,
        title: "Data Visualisation Projects",
        Desc: "The projects encompass various data visualization topics, ranging from chocolate brand popularity and sales trends to challenges like the Cat or Croissant game and a connected scatterplot for fuel prices and travel. They also include advanced analyses such as hotel revenue trends with SQL, diamond price prediction using Python, and the implementation of calculation groups for nuanced insights.",
        stack: "MS Power BI, Tableau, Python",
        Github: "https://github.com/sanikaardekar/Data-Visualization",
        Link: "http://bit.ly/3A5VQ1y",
        Mentions: "Workout Wednesday Challenges 2022 and 2023"
    },
]
export default analytics;